export function estimateRemainingMinutes({
  quota,
  usage,
  videoBitrate,
  audioBitrate,
  reserveRatio = 0.1
}) {
  if (![quota, usage, videoBitrate, audioBitrate].every(Number.isFinite)) return null;

  const freeBytes = Math.max(0, quota - usage) * (1 - reserveRatio);
  const bytesPerSecond = Math.max(1, (videoBitrate + audioBitrate) / 8);
  return Math.floor(freeBytes / bytesPerSecond / 60);
}

export function calculateDroppedFramePercent({ actualFps, targetFps }) {
  if (!(targetFps > 0) || !Number.isFinite(actualFps)) return null;

  return Math.round(Math.max(0, 1 - actualFps / targetFps) * 100);
}

export function classifyLoadRisk({ resolution, fps, charging, actualFps }) {
  let level = resolution === '4k' || fps >= 60
    ? 2
    : resolution === '1440p'
      ? 1
      : 0;

  if (charging && level > 0) level++;
  if (Number.isFinite(actualFps) && fps > 0 && actualFps / fps < 0.6) level = 3;

  return level >= 3 ? 'action-required' : level >= 1 ? 'warning' : 'healthy';
}

export function buildRecordingHealth(input) {
  const droppedFramePercent = calculateDroppedFramePercent(input);
  const action = input.writeFailed
    || input.lastChunkAgeMs > 10_000
    || droppedFramePercent > 40
    || input.loadRisk === 'action-required';
  const warning = input.lastChunkAgeMs > 3_000
    || (Number.isFinite(input.estimatedMinutes) && input.estimatedMinutes < 30)
    || droppedFramePercent > 20
    || input.loadRisk === 'warning'
    || (Number.isFinite(input.thermalStatus) && input.thermalStatus >= 4);

  return {
    status: action ? 'action-required' : warning ? 'warning' : 'healthy',
    signals: {
      writeFailed: !!input.writeFailed,
      loadRisk: input.loadRisk || 'healthy',
      thermalStatus: Number.isFinite(input.thermalStatus) ? input.thermalStatus : null
    },
    metrics: {
      actualFps: Number.isFinite(input.actualFps) ? input.actualFps : null,
      targetFps: Number.isFinite(input.targetFps) ? input.targetFps : null,
      droppedFramePercent,
      estimatedMinutes: input.estimatedMinutes ?? null,
      chunks: Number.isFinite(input.chunks) ? input.chunks : 0,
      bytes: Number.isFinite(input.bytes) ? input.bytes : 0,
      lastChunkAt: Number.isFinite(input.lastChunkAt) ? input.lastChunkAt : null,
      lastChunkAgeMs: Number.isFinite(input.lastChunkAgeMs) ? input.lastChunkAgeMs : null,
      storageSource: input.storageSource || null
    }
  };
}
